export const TRADE_WELCOME_PROMO_CODE = 'TRADEWELCOME';
export const TRADE_FIRST_WELCOME_PROMO_CODE = 'TRADE1STWELCOME';
